<div class="login-wallpaper">
    <!-- <img src="/assets/manna/login/login-bg-1.jpg"> -->
    <img class="background-img" src="/assets/app/login/sls-login-bg.jpg">

</div>
<img class="sls-logo" src="/assets/app/login/sls-logo-img.png">
<div class="container h-100" style="max-width: 1600px;">
    <div class="d-flex align-items-center justify-content-center h-100">
        <div class="ms-md-auto"
            style="background-color: #fff; border-radius: 0.5rem;  padding-left: 3rem; padding-right: 3rem;">
            <!-- <div style="border-top: 3px solid #057feb;width: 9rem;height: 1rem;"></div> -->
            <form class="npx-login-form" #ngForm1="ngForm" (ngSubmit)="ngForm1.valid && ngForm1Submit()">
                <div class="d-flex gap-2 mt-5 mb-4">
                    <img class="sls-icon" src="/assets/app/login/sls-icon-img.png">
                    <h3 class="mb-0">신화로직스 TMS</h3>
                </div>
                <div class="form-floating mt-3">
                    <input type="email" class="form-control" id="floatingInput" name="accountName"
                        [(ngModel)]="data.accountName" required placeholder="name@example.com">
                    <label for="floatingInput">ID</label>
                </div>
                <div class="form-floating mt-3">
                    <input type="password" class="form-control" id="floatingPassword" name="accountPasswd"
                        [(ngModel)]="data.accountPasswd" required placeholder="Password">
                    <label for="floatingPassword">PASSWORD</label>
                </div>
                <div class="checkbox mt-3 mb-3">
                    <label class="d-flex align-items-center">
                        <input type="checkbox" class="me-1" name="rememberMe" [(ngModel)]="data.rememberMe"> 로그인 정보 기억하기
                    </label>
                </div>

                <button class="w-100 btn btn-lg btn-primary" type="submit">로그인</button>
                <p class="mt-5 mb-3 text-muted">&copy; 2024 SHINHWA LOGISTICS SERVICE CO., LTD.</p>
            </form>
        </div>
    </div>
</div>